<div class="grid">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoListar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoListar">
			<div class="formgroup" *ngIf="permissaoInserir">
				<div class="p-fluid p-formgrid grid">
					<div class="field col-12 md:col-2">
						<button pButton pRipple routerLink="/apps/conta/inserir" label="Novo" icon="pi pi-plus"
							class="p-button-outlined sm:w-9rem"></button>
					</div>
				</div>
			</div>
			<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
				<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
			</div>
			<p-table #dt1 [value]="listaContas" dataKey="id" [rows]="10" [loading]="loadingContas" [rowHover]="true"
				[paginator]="true" [globalFilterFields]="['descricao', 'tipoConta']" responsiveLayout="stack"
				styleClass=" p-datatable-sm">
				<ng-template pTemplate="caption">
					<div class="flex justify-content-end flex-column sm:flex-row">
						<div class="p-fluid">
							<div class="flex">
								<span class="p-input-icon-left">
									<i class="pi pi-search"></i>
									<input pInputText type="text" #filter (input)="buscar(dt1, $event)"
										placeholder="Buscar" class="w-full" />
								</span>
								<span class="ml-2">
									<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
										pTooltip="Limpar Filtros" (click)="limpar(dt1)"></button>
								</span>
							</div>
						</div>
					</div>
				</ng-template>
				<ng-template pTemplate="header">
					<tr>
						<th pSortableColumn="descricao">
							Descrição
							<p-sortIcon field="descricao">
							</p-sortIcon>
						</th>
						<th pSortableColumn="tipoConta">
							Tipo
							<p-sortIcon field="tipoConta">
							</p-sortIcon>
						</th>
						<th style="text-align: center;">
							<div>
								Ações
							</div>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-item>
					<tr>
						<td>
							{{item.descricao}}
						</td>
						<td>
							{{item.tipoConta}}
						</td>

						<td style="text-align: center;">
							<div>
								<button *ngIf="permissaoEditar" pButton pRipple pTooltip="Editar"
									(click)="editarContaCliente(item.id)" icon="pi pi-pencil"
									class="p-button-success mr-2 mb-2"></button>
								<button *ngIf="permissaoExcluir" pButton pRipple pTooltip="Excluir"
									icon="pi pi-trash" (click)="excluir(item.id)"
									class="p-button-danger mr-2 mb-2 sm"></button>
							</div>
						</td>

					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Nenhum registro encontrado.</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Carregando contas. Por favor aguarde.</td>
					</tr>
				</ng-template>
			</p-table>
			<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
		</div>
	</div>
</div>